import { Homework } from '@shared/common';
import { genericMutation, genericMutationWithId, genericQueryWithParams } from './generics';
import { homeworksApis, meetingsApis } from '@shared/apis';

export const useCreateHomework = genericMutation<homeworksApis.CreateHomework>(
  homeworksApis.createHomework,
  meetingsApis.searchMyMeetings.endpoint
);
